module.exports = __webpack_public_path__ + "assets/img/bird.f9e5c83a.jpg";